import { isObject, isEmpty, isNil, trim } from 'lodash-es';
import moment from 'moment';
import numeral from 'numeral';

class System {

  public readonly moment = moment;
  public readonly numeral = numeral;
  public readonly store: { [key: string]: unknown } = {};
  public readonly settings: { [key: string]: unknown } = {};

  public isDefined(value) {
    // works with array and object
    if (isObject(value)) {
      // will return false for empty object and empty array
      return !isEmpty(value);
    } else {
      return !isNil(value) && value !== '';
    }
  }

  public isDefinedTrimmed(value) {
    if (typeof value === 'string') {
      value = trim(value);
    }
    return this.isDefined(value);
  }

  public datetimeFormat(date, format) {
    return isNil(date) ? '' : this.moment.utc(date).format(format);
  }

  public numberFormat(number, format) {
    return isNil(number) ? null : this.numeral(number).format(format);
  }

  public isAllDefined(...values) {
    return values.every(v => this.isDefined(v));
  }

  public getConsentUrl(tenantId: string, clientId: string, redirectUri: string) {
    // https://learn.microsoft.com/en-us/azure/active-directory/manage-apps/grant-admin-consent?pivots=portal#construct-the-url-for-granting-tenant-wide-admin-consent

    const consentUrl = `https://login.microsoftonline.com/${tenantId}/adminconsent?client_id=${clientId}&redirect_uri=${redirectUri}`;
    return consentUrl;
  }

}

const sys = new System();

export { sys };
